import { DAM_SVG } from 'components/Dam/DamAssets';
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Spinner } from 'reactstrap';

function DropZone({
  setimage,
  Heading = (
    <p>
      Drag and drop file here or <span className="color-underline">Choose file</span>
    </p>
  ),
  Description = (
    <div className="d-flex justify-content-center">
      <p>Minimum size 400px x 400px and aspect ratio 1:1 </p>
    </div>
  ),
  Src = '/manage/images/SVG/backup.svg',
  Loading = false,
}) {
  const [preview, setPreview] = useState([]);
  const [dragActiveGlobal, setDragActiveGlobal] = useState(false);

  const handleFile = (files) => {
    const file = files[0];
    setimage(file);

    setPreview([
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      }),
    ]);
    setDragActiveGlobal(false); // close overlay after drop
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    allowMultiple: false,
    onDrop: handleFile,
  });

  // ****** GLOBAL DRAG OVERLAY LISTENER ******
  useEffect(() => {
    const dragEnter = (e) => {
      e.preventDefault();
      setDragActiveGlobal(true);
    };

    const dragLeave = (e) => {
      e.preventDefault();
      if (e.clientX === 0 && e.clientY === 0) setDragActiveGlobal(false);
    };

    const dropAnywhere = (e) => {
      e.preventDefault();
      setDragActiveGlobal(false);
      if (e.dataTransfer.files?.length) handleFile(e.dataTransfer.files);
    };

    window.addEventListener('dragenter', dragEnter);
    window.addEventListener('dragover', dragEnter);
    window.addEventListener('dragleave', dragLeave);
    window.addEventListener('drop', dropAnywhere);

    return () => {
      window.removeEventListener('dragenter', dragEnter);
      window.removeEventListener('dragover', dragEnter);
      window.removeEventListener('dragleave', dragLeave);
      window.removeEventListener('drop', dropAnywhere);
    };
  }, []);

  return (
    <>
      {/* 🔥 FULL SCREEN DRAG OVERLAY */}
      {dragActiveGlobal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 999999,
            // background: 'rgba(0,0,0,0.45)',
            // backdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'auto', // this BLOCKS background interaction
          }}
        >
          {/* <h2 style={{ color: '#fff' }}>Drop file anywhere to upload</h2> */}
        </div>
      )}

      <div className="justify-content-center">
        <div className="row justify-content-center">
          {Loading ? (
            <div className="inputDrops" style={{ backgroundColor: '#FAFAFA', height: '238px' }}>
              <Spinner />
            </div>
          ) : (
            <div
              {...getRootProps()}
              className="inputDrops"
              style={{
                backgroundColor: isDragActive || dragActiveGlobal ? '#e0fcff' : '#FAFAFA',
                height: '238px',
              }}
            >
              <input {...getInputProps()} />
              <div>
                <div className="d-flex justify-content-center">{DAM_SVG.imageUploadIcon}</div>
                <div className="d-flex justify-content-center">{Heading}</div>
                {Description}
              </div>

              {preview?.length > 0 && (
                <div className="imagePreview">
                  {preview.map((upFile, idx) => (
                    <div className="previewImage" key={idx}>
                      <img src={upFile.preview} alt="preview" />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default DropZone;
